import { render, staticRenderFns } from "./ColorRenderer.vue?vue&type=template&id=20c8b44c"
import script from "./ColorRenderer.vue?vue&type=script&lang=js"
export * from "./ColorRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports